module.exports = __webpack_public_path__ + "media/images/icon_camera-384749e3fc2f0bbe5cc5c2beeaa25650.png";